export default "__VITE_ASSET__b1RuxFjl__"